import moment from "moment/moment";
import 'magnific-popup';
import 'slick-carousel';

jQuery( document ).ready(function($) {
  $('.menu-toggle').on('click', function(e){
    e.preventDefault();
    $('#menu').toggleClass('open');
  })

  $('.carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" aria-label="prev"><i class="fas fa-chevron-circle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fas fa-chevron-circle-right"></i></button>',
  });
  $('.music-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: $('.arrow-container'),
    prevArrow: '<button type="button" class="slick-prev" aria-label="prev"><i class="fas fa-chevron-circle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fas fa-chevron-circle-right"></i></button>',
  });

  $.ajax({
    url: 'https://rest.bandsintown.com/artists/Brantley Gilbert/events?app_id=45PRESS_brantley',
    method: 'GET',
    dataType: 'json',
    error: () => {
      alert('Error fetching events!')
    },
    success: data => {
      const events = $('#tourdates');
      
      let html = '';
      let n = 0
     
      if (data.length) {
        for (let event of data) {
            n++
            html += '<div class="event-group">'
            html += '<div class="event-info">';
            html += '<div class="event-date">' + moment(event.datetime).format('MMMM D, YYYY').toUpperCase() + '</div>'
            html += '<div class="event-venue">' + event.venue.name.toUpperCase() + '<br>' + event.venue.location.toUpperCase() + '</div>'
            html += '</div>';
            html += '<div class="event-links">'
            for (let offer of event.offers) {
              html += '<a href="' + offer.url + '" target="_blank" class="link btn dark">' + offer.type.toUpperCase() + '</a>';
            }
            html += '</div>'
            html += '</div>'
        }
        events.html(html)
      } else {
        events.html('<span class="no-events">Check back soon for new shows!</span>')
      }
    }
  })

  if ($('#popup').length > 0){
		$.magnificPopup.open({
			items: {
			  src: "#popup",
			  type: 'inline'
			}
		});
	}
});